import React from "react";
import { useLanguageContent } from "../../Components/LangueContentLoader";
import logo from "../../Images/CUEL/logo250x250.jpg";
import vid1 from "../../Videos/vid_1.mp4";
import vid1web from "../../Videos/vid_1_compat.webm";
import flyer from "../../Images/CUEL/flyerLBDU.png";
import sucette from "../../Images/CUEL/sucette.png";
import statsite from "../../Images/CUEL/statsite.png";
import concour from "../../Images/CUEL/concour.png";

export default function CUELProject() {
  const content = useLanguageContent();
  return (
    <main>
      <section>
        <h1 className="banner-text single-project-title">
          {content.Projet}&nbsp;
          <p className="salmon">{content.CUEL.title}</p>
        </h1>
        <h2>{content.Introduction}</h2>
        <p>{content.CUEL.intro}</p>
      </section>

      <section>
        <img className="img-projects" src={logo} alt="Logo of a company" />
      </section>

      <section>
        <h2>{content.CUEL.work}</h2>
        <p>
          {content.CUEL_work.map((objectif, index) => (
            <li key={index}>- {objectif}</li>
          ))}
        </p>
      </section>

      <section>
        <div className="img-projects video-container">
          <video controls preload="metadata" playsInline>
            <source src={vid1web} type="video/webm; codecs=vp9,opus" />
            <source src={vid1} type="video/mp4" />
            Votre navigateur ne supporte pas la vidéo HTML5.
          </video>
        </div>
        <p className="italique">{content.CUEL.desc5}</p>
      </section>

      <section>
        <h2>{content.CUEL.finalTitle}</h2>
        <p>{content.CUEL.final}</p>
      </section>

      <section>
        <img
          className="img-projects"
          src={flyer}
          alt="flyer for a restaurant"
        />
        <p className="italique">{content.CUEL.desc1}</p>
      </section>

      <div style={{ width: "100%", textAlign: "center" }}>
        <h2>{content.CUEL.finalTitle2}</h2>
      </div>

      <section>
        <img
          className="img-projects"
          src={sucette}
          alt="Affiche publicitaire pour l'enseigne Chez Ugo & Léa"
        />
        <p className="italique">{content.CUEL.desc2}</p>
      </section>

      <section>
        <img
          className="img-projects"
          src={statsite}
          alt="plusieurs tableaux Excel"
        />
        <p className="italique">{content.CUEL.desc3}</p>
      </section>
      <section>
        <img className="img-projects" src={concour} alt="Post d'un concours" />
        <p className="italique">{content.CUEL.desc4}</p>
      </section>
    </main>
  );
}
